import { getEnv } from "@/env";
import { useEffect } from "react";

export const useBranchIORender = () => {
  const NEXT_PUBLIC_MOBILE_BANNER_KEY = "NEXT_PUBLIC_MOBILE_BANNER_KEY";
  const bannerKey = getEnv(NEXT_PUBLIC_MOBILE_BANNER_KEY);

  useEffect(() => {
    async function initAndFetch() {
      try {
        const BranchSDK = (await import("branch-sdk")).default;
        BranchSDK.init(bannerKey!);
      } catch (error) {
        console.error("Failed to load Branch SDK:", error);
      }
    }
    if (
      !window.location.pathname.includes("/webview") &&
      !window.location.pathname.includes("/authx")
    ) {
      initAndFetch();
    }
  }, [bannerKey]);
};
